export enum ConsultingStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}

export enum ConsultingResponse {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  TIMEOUT = 'TIMEOUT',
}
